export enum LogOrigin {
    UNKNOWN = "Unknown",
    LOGGER = "Logger",
    LOGGER_TEST = "LoggerTEST",
    PLAYER_STATE_HELPER = "PlayerStateHelper",
    LOCAL_STORAGE_SAVER = "LocalStorageSaver",
    FACEBOOK_SAVER = "FBInstantSaver",
    GB_SAVER = "GameBackendSaver",
    FB_CTX_HANDLER = "FBContextHandler",
    COINBAR = "CoinBar",
    PRELEVEL_BOOSTER = "PrelvlBooster",
    CARD_STATE_HELPER = "CardStateHelper",
    FRIENDS_HUB_HANDLER = "FriendsHubHandler",
    PREMIUM_SPIN_PURCHASE = 'PremiumSpinPurcahse',
    CROP_GAME_OBJECT = 'CropGameObject',
    ANDROID_DRIVER = 'AndroidSDKDriver',
    CHEATS = 'Cheats',
    SENTRY = 'Sentry',
    FARM_UNLOCK_AREA = 'FarmUnlockArea',
}
